/* eslint-disable no-unused-vars */
import BreadTag from "components/dashboard/home/BreadTag";
import React, { useState, useEffect } from "react";
import { DiscoverAllCard } from "./DiscoverAllCard";
import { useNavigate } from "react-router-dom";
import { CourseServices } from "services/courses";
import { CardSkeleton } from "./CourseSkeleton";

const DiscoverAllCourses = () => {
  const roles = JSON.parse(sessionStorage.getItem("#roles") || "{}");

  // const navigate = useNavigate()
  const [isLoading, setLoading] = useState(false);
  const [Course, setCourses] = useState([]);
  const [endpoint, setApiEndpoint] = useState("");
  const [bgColor, setBgColor] = useState("");
  const [color, setColor] = useState("");
  const [rateBg, setRateBg] = useState("");
  const [textColor, setTextColor] = useState("");

  useEffect(() => {
    if (roles) {
      if (roles === "student") {
        setBgColor("bg-primary");
        setColor("primary");
        setTextColor("text-primary");
        setRateBg("bg-primary");
        setApiEndpoint("course/all?parameter=student");
      } else if (roles === "teacher") {
        setBgColor("bg-blueColor");
        setColor("blueColor");
        setTextColor("text-blueColor");
        setRateBg("bg-blueColor");
        setApiEndpoint("course/all?parameter=teacher");
      } else {
        setBgColor("bg-greenColor");
        setColor("greenColor");
        setTextColor("text-greenColor");
        setRateBg("bg-greenColor");
        setApiEndpoint("course/all?parameter=guest");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roles]);

  useEffect(() => {
    if (endpoint) {
      getAllCourses();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [endpoint]);

  const getAllCourses = async () => {
    setLoading(true);
    try {
      const response = await CourseServices.fetchCourses(endpoint);
      // console.log("fetch event", response);
      if (response.data.status === "success") {
        const res = response.data.data.details;
        setCourses(res?.rows);
        setLoading(false);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleViewClick = (id) => {
    const selectedCourse = Course.find((course) => course.id === id);
    // navigate("../my-courses/course-details", {
    //   state: { courseData: selectedCourse }, // Pass the entire row data as state
    // });
    localStorage.setItem("#enrolCourse", JSON.stringify(selectedCourse.id));
    console.log("View enrol course Detail", selectedCourse.id);
  };

  const navigate = useNavigate();
  return (
    <div className="p-6 bg-gray-100 flex-1 overflow-auto">
      <BreadTag
        item1={"Dashboard"}
        item2={"My Courses"}
        item3={"Discover All"}
        onClick1={() => navigate("../home")}
        onClick2={() => navigate("../my-courses")}
      />
      <div className="grid gap-6 lg:grid-cols-4 md:grid-cols-3 grid-cols-1 ">
        {isLoading ? (
          <CardSkeleton />
        ) : (
          Course.map((course) => (
            <DiscoverAllCard
              key={course.id}
              {...course}
              handleViewClick={handleViewClick}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default DiscoverAllCourses;
